import initGtag, { gtag } from "../plugins/gtm.mjs";
import { defineNuxtPlugin, useRuntimeConfig } from "#app";
export default defineNuxtPlugin(() => {
  const {
    public: {
      gtmKey,
      commerce: { analytics }
    }
  } = useRuntimeConfig();
  if (analytics === "party-town") {
    return {
      provide: {
        gtag
      }
    };
  }
  if (!gtmKey) {
    console.warn("No GTM key found in runtime config");
  }
  if (gtmKey) initGtag(gtmKey);
  return {
    provide: {
      gtag
    }
  };
});
